// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTimeCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PTimeCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PTimeCircleOutlined = function PTimeCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTimeCircleOutlinedSvg
  }));
};

PTimeCircleOutlined.displayName = 'PTimeCircleOutlined';
export default React.forwardRef(PTimeCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTimeCircleOutlined.js
// module id = 3683
// module chunks = 0